import { getRequest } from '../services/requestHandler';
import { HeadFinishForSaveDto } from '../models';

export const getPutterHeadFinishes = async () => {
  const url = 'putter/getPutterHeadFinishes?activeOnly=true';
  const response = await getRequest<HeadFinishForSaveDto>('GetPutterHeadFinishes', url);
  return response;
};
